import MaterialTable from "@material-table/core";
import React, { useState, useEffect, createRef } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { orderReleaseTable, theme } from "../constants";
import { getOrderDetails, releaseOrder, updatePoReady } from "../api";
import LoaderComponent from "../../LoaderComponent/LoaderComponent";
import OrderManagementHeader from "./orderManagementHeader";
import _ from "lodash";
import OrderManagementMaterialTable from "./orderManagementMaterialTable";

const tableRef = createRef();
const Orders = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(5000);
  const [pageNumber, setPageNumber] = useState(0);
  const [tableData, setTableData] = useState(Array(0));
  const onPageChange = (e) => {
    setPageNumber(e);
  };

  let selectedLocation = useSelector(
    (storeState) => storeState.selectedLocation
  );

  //on page load there won't be any location selected, so we are setting default to 'ECDC' location
  if (selectedLocation.length === 0) {
    selectedLocation = 25;
  }
  const [previousSelectedLocation, setLocation] = useState();

  useEffect(() => {
    if (!_.isEqual(previousSelectedLocation, selectedLocation)) {
      setLocation(selectedLocation);
    }
  });

  const getTableData = async () => {
    setIsLoading(true);
    try {
      const response = await getOrderDetails(
        selectedLocation,
        pageNumber,
        pageSize
      );
      setTableData(response);
    } catch (error) {
      setTableData(Array(0));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getTableData();
  }, [previousSelectedLocation]);

  const columns = [
    {
      title: "Order Number",
      field: "comarNumber",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Status",
      field: "machineStatus",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "From Location",
      field: "fromLocation",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "To Location",
      field: "toLocation",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Forwarder",
      field: "providerName",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Model",
      field: "prodDescr",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Serial Number",
      field: "serialNumber",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0",
      field: "poReady",
      headerStyle: {
        fontSize: "12px",
      },
      filtering: false,
      cellStyle: {
        width: "12px",
        whiteSpace: "nowrap",
      },
      width: "12px",
    },
    {
      title: "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0",
      field: "frwdNtfReady",
      headerStyle: {
        fontSize: "12px",
      },
      cellStyle: {
        width: "12px",
        whiteSpace: "nowrap",
      },
      filtering: false,
      width: "12px",
    },
  ];

  console.log("Columns:", columns);

  return (
    <div className="rounded-sm p-[5px] w-full">
      <OrderManagementHeader getTableData={getTableData} />
      <ThemeProvider theme={theme}>
        {isLoading && <LoaderComponent />}
        {!isLoading && (
          <OrderManagementMaterialTable
            columns={columns}
            tableName="OrderMangement"
            tableRef={tableRef}
            tableData={tableData}
            getTableData={getTableData}
          />
        )}
      </ThemeProvider>
    </div>
  );
};

export default Orders;
